module.exports = __webpack_public_path__ + "static/img/102.f694c5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/102.png
// module id = 9xvg
// module chunks = 0